import * as React from "react";
import { useParams } from "react-router-dom";

import ContributionForm from "../../../components/Forms/PaymentContributionRecord/FlowForm/FlowForm";

export default () => {
  const { paymentGroupId, brfPremisesId } = useParams();

  return <ContributionForm method="POST" paymentGroupId={paymentGroupId} brfPremisesId={brfPremisesId}/>;
};
